<template>
  <nav
    class="w-100 py-3 admin-navbar inline flex align-content-center flex-wrap"
  >
    <ConfirmDialog></ConfirmDialog>

    <!-- Left Section Navbar -->
    <Button
      class="flex-initial block lg:hidden"
      icon="pi pi-bars"
      outlined
      severity="secondary"
      style="border: none"
      @click="toggleMobileSidebar()"
    />
    <div class="flex items-center ml-2">
      <div class="text-center mr-3">
        <img :src="logo" alt="cp_logo" style="width: 75px" />
      </div>
      <div class="company-name">{{ userCompanyName }}</div>
    </div>

    <!-- Right Section Navbar -->
    <div class="flex justify-content-end align-items-center flex-auto">
      <div class="cursor-pointer mr-3 relative" @click="showNotif">
        <div
          v-if="(notificationData?.length ?? 0) > 0"
          class="notification absolute top-0 right-0 font-bold text-center"
        >
          {{ notificationData.length }}
        </div>
        <i class="far fa-bell" style="width: 24px; height: 24px"></i>
      </div>

      <img
        v-if="choosedLanguage == 'indonesia'"
        src="@/assets/images/icon-id-48.png"
        @click="toggleLanguage()"
        style="width: 32x; height: 32px; cursor: pointer"
      />
      <img
        v-else
        src="@/assets/images/icon-us-48.png"
        @click="toggleLanguage()"
        style="width: 32px; height: 32px; cursor: pointer"
      />

      <div
        class="flex align-items-center ml-3"
        style="cursor: pointer"
        @click="toggle"
      >
        <p class="m-0 mr-3" style="text-transform: uppercase">
          {{ userStoreName }}
        </p>
        <Avatar
          image="https://images.unsplash.com/photo-1506863530036-1efeddceb993?auto=format&fit=crop&q=80&w=1944&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          class="mr-2 my-auto"
          size="medium"
          shape="circle"
        />
      </div>
    </div>

    <!-- Menu Navbar -->
    <Menu ref="notif" :model="notificationData" :popup="true" class="notif p-2">
      <template #item="{ item }">
        <div
          class="py-2 px-3 cursor-pointer"
          @click="executeNotification(item)"
        >
          <h4 class="m-0 mb-2">{{ item.title }}</h4>
          <p class="m-0">{{ item.description }}</p>
        </div>
      </template>
    </Menu>
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true"></Menu>
  </nav>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useUserStore } from "@/stores/UserStore";
import { useGeneralStore } from "@/stores/GeneralStore";
import { usePartnerStore } from "@/stores/PartnerStore";
import { useCustomerStore } from "@/stores/CustomerStore";
import { useNotification } from "@/stores/NotificationStore";

import Avatar from "primevue/avatar";
import Button from "primevue/button";
import ConfirmDialog from "primevue/confirmdialog";
import Menu from "primevue/menu";

export default {
  name: "AdminNavbar",
  components: {
    Avatar,
    Button,
    ConfirmDialog,
    Menu,
  },
  data() {
    return {
      items: [
        {
          items: [
            {
              label: "Settings",
              icon: "pi pi-cog",
              command: () => {
                this.$router.push({ path: "/admin/user/setting" });
              },
            },
            {
              label: "Logout",
              icon: "pi pi-sign-out",
              command: () => {
                this.logout();
              },
            },
          ],
        },
      ],
      logo: "",
    };
  },
  computed: {
    ...mapState(useUserStore, {
      userStoreName: "user_id",
      userCompanyName: "company_name",
      userCompanyId: "company_id",
    }),
    ...mapState(useNotification, ["notificationData"]),
    ...mapWritableState(useGeneralStore, [
      "isLoading",
      "choosedLanguage",
      "isLogout",
    ]),
    ...mapWritableState(usePartnerStore, ["vendorData"]),
    ...mapWritableState(useCustomerStore, ["prefixData"]),

    choosedLang() {
      return this.choosedLanguage == "indonesia" ? "ENG" : "IND";
    },
  },
  methods: {
    ...mapActions(useGeneralStore, ["toggleMobileSidebar", "toggleLanguage"]),
    ...mapActions(useUserStore, ["userLogout", "getUser"]),
    ...mapActions(useCustomerStore, ["getCompanyPrefix"]),
    ...mapActions(useNotification, ["getNotification", "readNotification"]),

    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    showNotif(event) {
      if (this.notificationData && this.notificationData.length > 0) {
        if (this.$refs.notif) {
          this.$refs.notif.toggle(event);
        } else {
          console.error("Notification menu reference is not ready.");
        }
      } else {
        this.$toast.add({
            severity: "error",
            summary: this.$root.lang("no_data"),
            detail: `${this.$root.lang("no_notification")}.`,
            life: 5000,
          });
        console.warn("No notifications to display.");
      }
    },

    logout() {
      const vm = this;
      vm.isLogout = true;
      vm.$confirm.require({
        message: "All your unsaved data will be erased. Are you sure?",
        header: "Logout Confirmation",
        rejectClass: "p-button-text p-button-text",
        acceptClass: "p-button-danger p-button-text",
        accept: async () => {
          // Clear localStorage
          localStorage.clear();

          // Clear sessionStorage
          sessionStorage.clear();

          // Clear all cookies
          document.cookie.split(";").forEach((cookie) => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
          });

          // Call logout API and redirect
          await vm.userLogout();
          vm.$router.push({ path: "/" });
        },
        reject: () => {
          vm.isLogout = false;
          //do nothing
        },
      });
    },

    async getAllCompanyPrefix() {
      const vm = this;
      let params = {
        action: "get",
        name: "",
      };
      await vm.getCompanyPrefix(params);
    },

    async getUserInformation() {
      const vm = this;
      let params = {
        action: "get",
        user_id: vm.userStoreName,
        limit: -1,
        company_id: vm.userCompanyId,
      };

      let response = await vm.getUser(params);
      if (response.status == "ok") {
        let result = response.data;
        if (result.length > 0) {
          vm.logo = result[0].company_logo;
        }
      }
    },

    async getCurrentNotification() {
      const vm = this;
      let params = {
        action: "get",
        user_id: vm.userStoreName,
        company_id: vm.userCompanyId,
        is_read: 0,
        is_active: -1,
        limit: -1,
        offset: -1,
      };

      await vm.getNotification(params);
    },
    async executeNotification(item) {
      const vm = this;
      let params = {
        action: "get",
        notification_id: item.notification_id,
      };

      await vm.readNotification(params);
      vm.getCurrentNotification();

      this.$router.push(item.url);
    },
  },

  async beforeMount() {
    const vm = this;
    this.isLoading = true;
    await vm.getAllCompanyPrefix();
    await vm.getUserInformation();
    this.isLoading = false;
  },

  async mounted() {
    // Notification sudah tidak relevan, dinonaktifkan
    // this.getCurrentNotification();
    // setInterval(() => {
    //   this.getCurrentNotification();
    // }, 30000);
  },
};
</script>

<style>
.p-menu .p-submenu-header {
  display: none;
}
.p-menu {
  margin-top: 16px;
}
.p-menu .p-menuitem > .p-menuitem-content {
  background-color: transparent;
}
.p-menu .p-menuitem > .p-menuitem-content:hover {
  background-color: #f3f4f6;
}
.notif .p-menuitem {
  position: relative;
}
.notif .p-menuitem:not(:last-child):after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background-color: #ececec;
  margin: 0 10px;
}

.notif {
  left: auto !important;
  right: 10px !important;
  width: 100%;
  max-width: 500px;
}

.notification {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  transform: translate(6px, -6px);
  font-size: 12px;
  line-height: 18px;
  background-color: red;
  color: white;
  user-select: none;
}

@media (max-width: 767px) {
  .company-name {
    display: none;
  }
}
@media (max-width: 500px) {
  .notif {
    width: calc(100vw - 20px);
  }
}
</style>
